<template>
        <div class="chtBox">
            <DxChart id="chart"
                     :data-source="dataSource"
                     title="Tägliche Seitenaufrufe"
                     container-background-color="white"
                     palette="pastel">
                <DxTitle text="Tägliche Seitenaufrufe">
                    <DxFont color="white"></DxFont>
                </DxTitle>
                <DxArgumentAxis argument-type="datetime">
                    <DxLabel format="monthAndDay" />
                </DxArgumentAxis>

                <DxValueAxis>
                    <DxTick :visible="false" />
                    <DxLabel :visible="false" />
                </DxValueAxis>

                <DxSeries argument-field="AccessDate"
                          value-field="ViewsCount"
                          type="spline">
                    <DxLabel :visible="true"
                             background-color="#c18e92" />
                </DxSeries>

                <DxLegend :visible="false" />

                <DxExport :enabled="true" />

            </DxChart>
        </div> 
</template>

<script> 
    import {
        DxChart,
        DxSeries,
        DxArgumentAxis,
        //DxCommonSeriesSettings,
        DxExport,
        //DxGrid,
        //DxMargin,
        DxLegend,
        DxTitle,
        DxFont,
        //DxSubtitle,
        //DxTooltip,
    } from 'devextreme-vue/chart'; 
    export default {
        name: 'UserStats',
        components: {
            DxChart,
            DxSeries,
            DxArgumentAxis,
            //DxCommonSeriesSettings,
            DxExport,
            //DxGrid,
            //DxMargin,
            DxLegend,
            DxTitle,
            //DxSubtitle,
            //DxTooltip,
            DxFont
        },
        data() {
            return {
            };
        },
        computed: {
            dataSource() {
                return this.$store.state.statisticsStore.userStats
            },
        },
        created: function () {
            this.$store.dispatch("getUserStats")
        },
    }

</script>
<style scoped>
    .chtBox {
        background: #ffffff1a;
    }
</style>